<template>
    <div class="star" :style="{'margin-top': properties.topMargin + 'px', 'margin-left': properties.leftMargin + 'px'}">
    <transition name="fade"><span v-if="show">.</span></transition>
    </div>
</template>
<script>
import math from './mixins/math'
export default {
    data(){
        return{
            show: true,
            twinkle: null
        }
    },
    props: ["properties"],
    mixins:[math],
    mounted: function(){
        if(this.properties.twinkle) 
        this.twinkle = setInterval(()=>{
            this.show = !this.show;
        },this.randomRange(500,3000))
    },
    beforeDestroy: function(){
        clearInterval(this.twinkle);
    }
}
</script>
<style scoped>
.star{
    position: absolute;
    text-align: center;
    align-content: center;
    width: 5px;
    height: 5px;
    color: azure;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>